export interface EstensaFault {
    createdOn: string;
    estensaFaultDetails: EstensaFaultDetails;
    exceptionMessage: string;
    exceptionTypeName: string;
    httpStatusCode: number;
    id: string;
}

export interface EstensaFaultDetails {

}

const lockFaultTypeNames = ['Estensa.Web.Exceptions.LockedFault', 'Estensa.Web.Exceptions.UnlockedFault'] as const;
export interface EstensaLockFault extends EstensaFault {
    error: {
        exceptionTypeName: (typeof lockFaultTypeNames)[0] | (typeof lockFaultTypeNames)[1];
        estensaFaultDetails: any;
    };
}

const MergeFaultTypeName = 'Estensa.Web.Exceptions.DetailCreatedWhileReportingFault' as const;
export interface EstensaMergeFault extends EstensaFault {
    error: {
        exceptionTypeName: typeof MergeFaultTypeName;
    };
}

export function isExtensaFault(ex: any): ex is EstensaFault {
    return typeof ex?.exceptionTypeName === 'string';
}

export function isExtensaLockFault(ex: unknown): ex is EstensaLockFault {
    return isExtensaFault(ex) && lockFaultTypeNames.includes(ex.exceptionTypeName as any);
}

export function isMergeFault(ex: unknown) {
    return isExtensaFault(ex) && ex.exceptionTypeName === MergeFaultTypeName;
}
